module.exports = "<p>\n  dummy works!\n</p>\n"